// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"466":"component---src-pages-create-new-js","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"466":"996ba293cf3de2f09a63","532":"f209baa64305f6df7d26","678":"2ecbcd712e66b719ba1f","883":"da19968e4b00979f9461"}[chunkId] + ".js";
};